import Vue from 'vue'
Vue.component('AppButton', () => import('../components/AppButton'))
Vue.component('AppToolbar', () => import('../components/AppToolbar'))
Vue.component('FileUploaderExtended', () => import('../components/FileUploaderExtended'))
Vue.component('FileUploaderAdvanced', () => import('../components/FileUploaderAdvanced'))
Vue.component('FileUploader', () => import('../components/FileUploader'))
Vue.component('VueEditor', () => import('../components/VueEditor'))
// Vue.component('GlobalSearch', () => import('../components/GlobalSearch'))
// Vue.component('PdfThumbnail', () => import('../components/PdfThumbnail'))
